const DEBUG = true;
const logger = {
  info(message, payload) {
    if (typeof window === "undefined") return;
    if (window.__ZIGGY_DEBUG__ !== true) return;
    if (!DEBUG) return;
    console.info(`[DescriptionTabs] ${message}`, payload ?? "");
  },
};

class DescriptionTabs extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.tabs = Array.from(this.querySelectorAll("[data-description-tab]"));

    if (!this.tabs.length) return;

    logger.info("init", { count: this.tabs.length });

    this.tabs.forEach((tab) => this.initTab(tab));
  }

  initTab(tab) {
    const button = tab.querySelector("[data-description-tab-toggle]");
    const panel = tab.querySelector("[data-description-tab-panel]");
    const icon = tab.querySelector("[data-description-tab-icon]");

    if (!button || !panel) return;

    const open = () => {
      // fermer les autres
      this.tabs.forEach((otherTab) => {
        if (otherTab === tab) return;

        const otherPanel = otherTab.querySelector(
          "[data-description-tab-panel]",
        );
        const otherButton = otherTab.querySelector(
          "[data-description-tab-toggle]",
        );
        const otherIcon = otherTab.querySelector("[data-description-tab-icon]");

        otherPanel.style.maxHeight = "";
        otherIcon?.classList.remove("is-open");
        otherButton?.setAttribute("aria-expanded", "false");
        otherTab.removeAttribute("data-open");
      });

      panel.style.maxHeight = panel.scrollHeight + "px";
      icon?.classList.add("is-open");
      button.setAttribute("aria-expanded", "true");
      tab.setAttribute("data-open", "");
    };

    const close = () => {
      panel.style.maxHeight = "";
      icon?.classList.remove("is-open");
      button.setAttribute("aria-expanded", "false");
      tab.removeAttribute("data-open");
    };

    // état initial
    if (tab.hasAttribute("data-open")) open();

    button.addEventListener("click", (e) => {
      e.preventDefault();

      const isOpen = button.getAttribute("aria-expanded") === "true";

      if (isOpen) {
        close();
      } else {
        open();
      }
    });
  }
}
if (!customElements.get("description-tabs")) {
  customElements.define("description-tabs", DescriptionTabs);
}
